import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetch_firm_settings } from "../redux/actions";
import { withRouter } from "react-router-dom";
import SubscriptionExpirationAlert from "../../../common/components/SubscriptionExpirationAlert";

class FirmSettingContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubscriptionAlert: false,
    };
    this.togglePopup = this.togglePopup.bind(this);
  }

	componentDidMount() {
		this.props.fetch_firm_settings();
	}

  	componentDidUpdate(prevProps) {
    	if (prevProps.firmSettings !== this.props.firmSettings) {
      		this.handleFirmSettingsChange();
    	}
  	}

 	handleFirmSettingsChange() {
    	const { firmSettings, history } = this.props;
		if (
			firmSettings.companyId === "/PaidAlerts" ||
			firmSettings.companyId === "/FreeAlerts"
		) {
			history.push("/ACEalerts");
		}
		if (firmSettings.subscriptionStatus !== "active") {
			this.setState({ ...this.state, showSubscriptionAlert: true });
		}
 	}

  	togglePopup() {
    	this.setState({
      	...this.state,
      	showSubscriptionAlert: false,
    	});
  	}

	render() {
		return (
      		<React.Fragment>
        		<div className={"FirmSettings"} />
        		<SubscriptionExpirationAlert
          			showSubscriptionAlert={this.state.showSubscriptionAlert}
          			updateSubscriptionStatus={this.togglePopup}
        		/>
      		</React.Fragment>
    	);
  	}
}

const mapStateToProps = (state) => {
	return {
		firmSettings: state.firmSettings
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetch_firm_settings: () => dispatch(fetch_firm_settings())
	}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FirmSettingContainer));


// WEBPACK FOOTER //
// ./src/settings/firm/component/FirmSettingContainer.js